import React from 'react';
import classNames from 'classnames';

import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import {
  selectInvertColors,
  selectLoaderComplete,
  soundEnabled,
} from 'src/state';

import { Logo } from './Logo';
import { PlanetModal } from './PlanetModal';
import { MobileCreditsOverlay } from './MobileCreditsOverlay';
import { LandingOverlay } from './LandingOverlay';
import { Buttons } from './Buttons';
import styles from './Container.module.css';

export function Container() {
  const dispatch = useAppDispatch();
  const loadingComplete = useAppSelector(selectLoaderComplete);
  const invertColors = useAppSelector(selectInvertColors);

  const onClick = () => {
    if (loadingComplete) dispatch(soundEnabled());
  }

  const containerClasses = classNames(
    styles['container'],
    {
      [styles['container--invert-colors']]: invertColors,
    },
  );

  return (
    <div className={containerClasses} onClick={onClick}>
      <MobileCreditsOverlay />
      <LandingOverlay />
      <Logo />
      <PlanetModal />
      <Buttons />
    </div>
  );
}
